//import SelectDateArrTwoCalendarArea from "@/pcomponents/common/crud/calendar/area/select_date_arr_two_cal";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import SelectDateArea from "./area/select_date";
import SelectBoxBar from "@/pcomponents/common/crud/write/select_box_bar";

function SelectDateArrTwoCalendarArea(props: any) {
  let myProps = {
    select_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    set_select_date: (inData: any) => { },
    select_date_arr: [],
    set_select_date_arr: (inData: any) => { },
    able_days_of_week: [1, 2, 3, 4, 5],
    set_able_days_of_week: (inData: any) => { },
    ...props
  };
  let select_date = myProps.select_date;;
  let select_date_arr = myProps.select_date_arr;
  let able_days_of_week = myProps.able_days_of_week;
  let next_month_date_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(myProps.select_date), 'month', +1), "Y-m-d");

  return (
    <div>
      <div className='text-center'>
        날짜
        <span style={{ color: "#999", marginLeft: 5 }}>
          ({select_date_arr.length}개 선택됨)
        </span>
        <button className="btn-s btn-dark ml-1" onClick={() => { myProps.set_select_date_arr([]); }}>선택초기화</button>
        <span className="ml-1">요일</span>
        <span style={{ display: "inline-block", marginLeft: "5px" }}>
          <SelectBoxBar
            valueTextArr={DateFunc.get_select_days_of_week()}
            value={myProps.able_days_of_week.join(",")}
            on_change={(inData: any) => {
              myProps.set_able_days_of_week(inData.value.split(","));
            }}
            is_arr_value={true}
          ></SelectBoxBar>
        </span>
      </div>
      <div>
        <SelectDateArea
          select_date={select_date}
          select_date_arr={select_date_arr}
          set_select_date_arr={(inData: any) => {
            myProps.set_select_date_arr(inData);
          }}
          able_days_of_week={able_days_of_week}
        ></SelectDateArea>
      </div>
      <div className="mt-1">
        <SelectDateArea
          select_date={next_month_date_str}
          select_date_arr={select_date_arr}
          set_select_date_arr={(inData: any) => {
            myProps.set_select_date_arr(inData);
          }}
          able_days_of_week={able_days_of_week}
        ></SelectDateArea>
      </div>
    </div>
  );
};
export default SelectDateArrTwoCalendarArea;